import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import styles from './styles.module.scss';
import TitleView from 'shared_features/title';
import Copy from 'shared_features/svgs/copy';
import Trash from 'shared_features/svgs/trash';
import Spinner from 'shared_features/spinner';

class View extends Component {

    componentDidMount() {
        this.props.fetchPrograms();
        this.checkForProgramCopy();
    }

    checkForProgramCopy = () => {
        const copyData = localStorage.getItem('copyProgramData');
        if (copyData) {
            try {
                const { programId, programName, sourceOrg, timestamp } = JSON.parse(copyData);

                // Check if this is a recent copy attempt (within 10 seconds)
                if (Date.now() - timestamp < 10000) {
                    // Remove the data to prevent duplicates
                    localStorage.removeItem('copyProgramData');

                    // Trigger the copy
                    this.handleProgramCopy(programId, programName, sourceOrg);
                }
            } catch (error) {
                console.error('Error parsing copy program data:', error);
                localStorage.removeItem('copyProgramData');
            }
        }
    }

    handleProgramCopy = (programId, programName, sourceOrg) => {
        const confirmed = window.confirm(
            `Do you want to copy "${programName}" to your organization? This will create a new program in your workspace.`
        );

        if (confirmed) {
            // Use the existing duplicate program action but with the source program ID
            this.props.duplicateProgram(programId);
        }
    }

    _renderEmpty() {
        const { currentTab } = this.props;

        if (currentTab === 'all') {
            return (<div className={styles.emptyContainer}>
                <div className={styles.dashedContainer}>
                    <h2 className={styles.subheader}>Create your first program</h2>
                    <div className={styles.description}>We highly recommend watching this quick tutorial video before you get started</div>
                    <iframe
                        src='https://www.youtube.com/embed/8EOzGSRBfcE?rel=0&modestbranding=1'
                        className={styles.video}
                        frameBorder='0'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                        allowFullScreen
                        referrerPolicy="strict-origin-when-cross-origin"
                        title='Create Program Tutorial'
                    />
                    <Link to='/programs/new'>
                        <div className={styles.createButton}>Create a program</div>
                    </Link>
                </div>
            </div>);
        }

        // For Private and Public tabs, show a simple empty message
        const tabLabel = currentTab === 'private' ? 'private' : 'public';
        return (<div className={styles.emptyContainer}>
            <div className={styles.dashedContainer}>
                <h2 className={styles.subheader}>No {tabLabel} programs</h2>
                <div className={styles.description}>
                    {currentTab === 'private' ?
                        'You don\'t have any private programs yet.' :
                        'You don\'t have any public programs yet.'
                    }
                </div>
            </div>
        </div>);
    }

    _renderPrograms() {
        return this.props.programs.map((program) => {
            const url = `/programs/${program.id}`;
            let name;
            let style;
            if (program.name) {
                name = program.name;
                style = styles.program;
            } else {
                name = 'UNNAMED';
                style = styles.unnamedProgram;
            }

            return (<div className={styles.container} key={`program${program.id}`}>
                <Link className={style} to={url}>
                    {name}
                </Link>
                {program.authorInfo && (
                    <div className={styles.author}>
                        {program.authorInfo.avatar ? (
                            <img
                                src={program.authorInfo.avatar}
                                alt={program.authorInfo.name}
                                className={styles.authorAvatar}
                            />
                        ) : (
                            <div className={styles.authorAvatarPlaceholder}>
                                {program.authorInfo.name ? program.authorInfo.name.charAt(0).toUpperCase() : '?'}
                            </div>
                        )}
                        <span className={styles.authorName}>{program.authorInfo.name}</span>
                    </div>
                )}
                <div className={styles.options}>
                    <span onClick={() => this.props.duplicateProgram(program.id)}><Copy />COPY</span>
                    <span onClick={() => window.confirm("Are you sure?") && this.props.deleteProgram(program.id)}><Trash />DELETE</span>
                </div>
            </div>);
        });
    }

    _renderTabs() {
        const { currentTab, updateCurrentTab } = this.props;
        const tabs = [
            { key: 'all', label: 'All' },
            { key: 'private', label: 'Private' },
            { key: 'public', label: 'Public' }
        ];

        return (
            <div className={styles.tabsContainer}>
                {tabs.map(tab => (
                    <button
                        key={tab.key}
                        className={`${styles.tab} ${currentTab === tab.key ? styles.activeTab : ''}`}
                        onClick={() => updateCurrentTab(tab.key)}
                    >
                        {tab.label}
                    </button>
                ))}
                <Link to='/programs/new' className={styles.mobileCreateButton}>+</Link>
            </div>
        );
    }

    render() {
        return (
            <div>
                <TitleView title='Select Program'>
                    <Link to='/programs/new' className={styles.desktopCreateButton}>+ CREATE PROGRAM</Link>
                </TitleView>
                {this._renderTabs()}
                <div className="main">
                    {this.props.isLoading ? (
                        <div className={styles.loadingContainer}>
                            <Spinner />
                        </div>
                    ) : (
                        this.props.programs.length <= 0 ? this._renderEmpty() : this._renderPrograms()
                    )}
                </div>
            </div>
        );
    }
}

export default View;
